const apiConfig = {

  apiUrl: "https://api.srishivatravels.com/api"
  // apiUrl: "http://192.168.0.60:8080/api"
  // apiUrl: "http://localhost:3360/api"

};

export default apiConfig;